export enum StatusClass {
  OK = 'ok',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum StatusIconAssetLocation {
  NONE = '',
  OK = '/assets/img/success.svg',
  WARNING = '/assets/img/warning.svg',
  ERROR = '/assets/img/error.svg',
}

export enum StatusText {
  NONE = '',
  OK = 'Connected',
  WARNING = 'Warnings',
  ERROR = 'Critical',
}
